import { Link } from "react-router-dom";
import "./sub-menu.scss";

type LinkProp = { linkTo: string; linkName: string };

type SubMenuProps = {
  menuItems: LinkProp[];
};

const SubMenu = ({ menuItems }: SubMenuProps) => {
  return (
    <>
      <div className="sub-menu-wrapper">
        <ul className="sub-menu">
          {menuItems.map((item, ind) => (
            <li
              key={item.linkTo + "-" + ind}
              id={item.linkTo + "-" + ind}
              className="sub-menu__item"
            >
              <Link to={item.linkTo} className="sub-menu__item__link">
                {item.linkName}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default SubMenu;
